import { HTML_BODY_TYPE, TEXT_BODY_TYPE } from '../utils/getDefaultBodyType';
import { OnSuccessfulSendFromInlineComposeName } from 'owa-mail-compose-action-names';
import bodyContentType from 'owa-service/lib/factory/bodyContentType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { action } from 'satcheljs/lib/legacy';
export var onSuccessfulSendFromInlineComposeAction = action(OnSuccessfulSendFromInlineComposeName)(function onSuccessfulSendFromInlineComposeAction(conversationId, itemId, body, markAsPending, isDifferentFrom) {
    // No-op
    // This is called to raise a stitch set up by owa-mail-reading-pane.
});
export default function onSuccessfulSendFromInlineCompose(viewState, markAsPending) {
    var bodyType = viewState.bodyType == 'HTML' ? HTML_BODY_TYPE : TEXT_BODY_TYPE;
    var bodyContent = viewState.content;
    // If we're using the default from address, continue local lie.
    // This will only be different for situations which we can't reconcile local lie fully, like replying to connected accounts
    var userConfig = getUserConfiguration();
    var address = isConsumer()
        ? userConfig.SessionSettings.DefaultFromAddress
        : userConfig.UserOptions.SendAddressDefault;
    if (!address) {
        address = userConfig.SessionSettings.UserEmailAddress;
    }
    var isDifferentFrom = viewState.fromViewState.from && viewState.fromViewState.from.email
        ? viewState.fromViewState.from.email.EmailAddress != address
        : false;
    // The local lie body will be displayed in the reading pane, so we need the content without removing the src attributes.
    var localLieBody = bodyContentType({ BodyType: bodyType, Value: bodyContent });
    onSuccessfulSendFromInlineComposeAction(viewState.conversationId, viewState.itemId ? viewState.itemId.Id : null, localLieBody, markAsPending, isDifferentFrom);
}
//# sourceMappingURL=onSuccessfulSendFromInlineCompose.js.map